import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { discoverCards } from '../../data/homepage';

/** Les trois cartes vert pâle du bas de page d'accueil. */
export function DiscoverCards() {
  return <section aria-label="À découvrir" className="mx-auto w-full max-w-[1400px] px-5 lg:px-10" data-id="element-1739" data-mp="3ruxzdi9k7u0a">
      <ul className="grid gap-5 md:grid-cols-3" data-id="element-1740" data-mp="3mt8k1qfb0u6e">
        {discoverCards.map(card => {
        const label = `${card.title} — ${card.label}`;
        const inner = <>
              <div className="flex items-start justify-between gap-4" data-id="element-1741" data-mp="3vuoutza16yb5">
                <span className="rounded-full bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-[0.08em] text-ville-navy" data-id="element-1742" data-mp="ef01lb6hxjry">
                  {card.label}
                </span>
                <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-white text-ville-navy transition-transform duration-150 ease-ville group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1743" data-mp="newtrms3h0rr">
                  <ArrowRightIcon className="h-4 w-4" data-id="element-1744" data-mp="2tvs0l4vl4i0d" />
                </span>
              </div>

              <img src={card.image} alt="" className="mx-auto mt-6 h-40 w-40 rounded-full object-cover lg:h-48 lg:w-48" data-id="element-1745" data-mp="2xxd8ebt9i63p" />

              <h3 className="mt-6 text-center font-display text-2xl font-extrabold uppercase leading-tight tracking-tight text-ville-navy" data-id="element-1746" data-mp="37urlq2jw2ers">
                {card.title}
              </h3>
            </>;
        const className = 'group flex h-full flex-col bg-ville-mist p-6 transition-colors duration-150 ease-ville hover:bg-ville-sand focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue';
        return <li key={card.id} data-id="element-1747" data-mp="3vjkke6rwb0q3">
              {card.href ? <a href={card.href} aria-label={label} className={className} data-id="element-1748" data-mp="3vh7u96bzhk1y">
                  {inner}
                </a> : <Link to={card.to ?? '/'} aria-label={label} className={className} data-id="element-1749" data-mp="3at6zwc5p7mkq">
                  {inner}
                </Link>}
            </li>;
      })}
      </ul>
    </section>;
}